module.exports = __webpack_public_path__ + "static/customer-bg-f87168d972050e29f78d080020499ba7.png";